import type { ReactNode } from "react";
import cx from "ui/cx";
import styles from "./LineCapsule.module.scss";

export interface LineCapsuleProps extends React.HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  icon?: ReactNode;
}

export default function LineCapsule({ label, icon, className, ...props }: LineCapsuleProps) {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <span>{label}</span>
    </div>
  );
}
